/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios, {AxiosResponse, AxiosError} from 'axios';
import aws4Interceptor from './aws4Interceptor';
import { makeCognitoRequest } from '../api/AWS';

let userData:any = [];

const getZoneID = () => {
  const userLocalData = localStorage.getItem('userData');

  if(userLocalData) {
    userData = JSON.parse(userLocalData);
  }
  return parseInt(sessionStorage.getItem('currentZone') || localStorage.getItem('currentZone') || userData.zoneId)
}

export enum HttpMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Patch = 'PATCH',
  Delete = 'DELETE',
}

export interface InterceptorOptions {
  service: string;
  region: string;
}

export interface ICredentials {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken?: string;
}

const signCurrentRequest = (config: any) => {
  const interceptor = aws4Interceptor(
    {
      region: process.env.REACT_APP_AWS_CONFIG_REGION || '',
      service: "execute-api",
    },
    {
    accessKeyId: localStorage.getItem('accessKeyId') || '',
    secretAccessKey: localStorage.getItem('secretAccessKey') || '',
    sessionToken: localStorage.getItem('sessionToken') || ''
    }
  );
  return interceptor(config);
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  // console.info(`[response] [${JSON.stringify(response)}]`);
  return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  // A request signed with SigV4 cannot be replayed after a 401: its signature
  // includes the request timestamp and body. Retrying the same Axios config
  // created an unbounded 401 loop while the caller had already received an
  // error. Let the original caller decide how to recover instead.
  return Promise.reject(error);
};

const getEncodedZoneList = () => {
  return localStorage.getItem('encoded_zones')
}

const getEncodedUserMeta = () => {
    return localStorage.getItem('user_meta')
}

export const getUserData = (key?: any) => {
  const userLocalData = localStorage.getItem('userData');

  if (userLocalData) {
    userData = JSON.parse(userLocalData);
  }
  if (!key) {
    return {
      email: userData['email'],
      name: userData['fullName'],
      role: userData['role'],
      user_id: userData['userId'],
      tz_name: userData['tz_name'],
      global: sessionStorage.getItem('globalZone') === "true"
    }
  }
  return userData[key]
}

// Sign each request exactly once with the credentials that are current at send
// time. Cognito credentials rotate in localStorage, so a module-level signer
// would eventually keep producing invalid signatures.
axios.interceptors.request.use(signCurrentRequest, onRequestError);
axios.interceptors.response.use(onResponse, onResponseError);

export const httpClient = (url: string, method: HttpMethod, bodyData: any) => {
  return new Promise((resolve, reject) => {
    const baseURL = process.env.REACT_APP_BASE_API_URL;
    const params: any = {method, url: `${baseURL}${url}`};
    const userData = getUserData()
    if(bodyData) {
      params.body = bodyData
      params.body = Object.assign({}, params.body, {
          zones: getEncodedZoneList(),
          zoneId: getZoneID(),
          userMeta: getEncodedUserMeta(),
          user_email: userData.email,
          global: userData.global
      })
    } else {
      params.body = {
          zones: getEncodedZoneList(),
          zoneId: getZoneID(),
          userMeta: getEncodedUserMeta(),
          user_email: userData.email,
          global: userData.global
      }
    }
    try {
        const data = axios({
          data: JSON.stringify(params.body),
          method: method,
          url: `${baseURL}${url}`, // compulsory
        });
      /* istanbul ignore next */
        data.then((response) => {
          // console.log('Successfully received data: ', response);
          resolve(response);
        }).catch((error) => {
          if(error.response.data === undefined) {
            reject(error);
            return
          } else if (error?.response?.data?.message === "The security token included in the request is expired") {
              localStorage.clear();
              reject(error);
              window.location.reload();
          }
          reject(error);
        });
    } catch (error) {
      // console.log('An error occurred', error);
      reject(error);
    }
  });
};

export const getAccessToken = (): Promise<string | void> => {
  const idToken = localStorage.getItem('idToken');

  const accessToken = makeCognitoRequest(idToken || /* istanbul ignore next */'').then((result:any) => {
    return result.sessionToken;
  }).catch((e) => console.log(e));

  return accessToken;
};
